import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IBranchInspection } from '../interfaces';
import { BranchInspectionMapper } from '../mappers';

export type IGetBranchInspectionsRepoResponse = IRepoResponse<200, { data: IBranchInspection[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBranchInspectionsRepo = IRepo<[any], IGetBranchInspectionsRepoResponse>;

export const GetBranchInspectionsRepoType = Symbol.for('GetBranchInspectionsRepo');

@bind(GetBranchInspectionsRepoType)
export class GetBranchInspectionsRepo implements IGetBranchInspectionsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/branch_inspections', query) });

      if (result.status === 200) {
        const data: IBranchInspection[] = result.data.data?.map(BranchInspectionMapper.toDomain) || [];
        const total = result.data.meta?.total || data.length;

        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
